import createReactComponent from '../createReactComponent';
export default createReactComponent('download', 'Download', [["path",{"d":"M4 16.004V17a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1M12 4.5v11m3.5-3.5L12 15.5 8.5 12","key":"svg-0"}]]);